import { render, staticRenderFns } from "./KPIItemEdit.vue?vue&type=template&id=22a75c8e"
import script from "./KPIItemEdit.vue?vue&type=script&lang=js"
export * from "./KPIItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports